import { createRouter, createWebHistory } from 'vue-router'
import { getTokens } from '@/lib/db'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/onboard', component: () => import('@/views/Onboard.vue'), meta: { public: true } },
  { path: '/home', component: () => import('@/views/Home.vue') },
  { path: '/projects', component: () => import('@/views/Projects.vue') },
  { path: '/schedule', component: () => import('@/views/Schedule.vue') },
  { path: '/inventory', component: () => import('@/views/Inventory.vue') },
  { path: '/inventory/consume', component: () => import('@/views/InventoryConsume.vue') },
  { path: '/inventory/purchase-request', component: () => import('@/views/PurchaseRequest.vue') },
  { path: '/expenses', component: () => import('@/views/Expenses.vue') },
  { path: '/pedidos', component: () => import('@/views/Pedidos.vue') },
  { path: '/albaran', component: () => import('@/views/Albaran.vue') },
  { path: '/settings', component: () => import('@/views/Settings.vue') },
  { path: '/:catchAll(.*)', redirect: '/onboard' },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true
  const tokens = await getTokens()
  if (!tokens) return { path: '/onboard', query: { next: to.fullPath } }
  return true
})
